import React from 'react';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart as LineChartUI,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { IGraphLine } from './types';
import ToolTipGraphic from '../../UI/ToolTipGraphic';
import { COLORS } from '../../constants';

const LineChart: React.FC<IGraphLine> = ({ data }) => {
  return (
    <ResponsiveContainer height={300} width="95%">
      <LineChartUI>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          type="category"
          allowDuplicatedCategory={false}
          dataKey="date"
          tickLine={false}
          fontSize={0}
        />
        <YAxis width={80} />
        <Tooltip content={<ToolTipGraphic />} />
        <Legend />
        {data.map((s, i) => (
          <Line
            stroke={COLORS[i % COLORS.length]}
            strokeWidth={2}
            dataKey="value"
            data={s.data}
            name={s.name}
          />
        ))}
      </LineChartUI>
    </ResponsiveContainer>
  );
};

export default LineChart;
